import { render, staticRenderFns } from "./ClinicalResearchList.vue?vue&type=template&id=797044e8&scoped=true"
import script from "./ClinicalResearchList.vue?vue&type=script&lang=js"
export * from "./ClinicalResearchList.vue?vue&type=script&lang=js"
import style0 from "./ClinicalResearchList.vue?vue&type=style&index=0&id=797044e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797044e8",
  null
  
)

export default component.exports